import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

const withModalLayoutContainer = (ChildComponent) => {
  class ModalLayoutContainer extends React.Component {
    render () {
      return (
        <div className={`modal-wrapper ${this.props.modalClass || ''}`}>
            <div className="modal-close">
                <CloseIcon classes={{ root: "close-icon" }} onClick={this.props.onCloseClick} />
            </div>
            <div className="modal-content">
                <ChildComponent {...this.props} />
            </div>
        </div>
      );
    }
  }
  return ModalLayoutContainer;
};

export default withModalLayoutContainer;
